export enum SortOrderEnum {
  Ascending = 'asc',
  Descending = 'desc',
}